import { render } from "./dol-radio.vue?vue&type=template&id=71d81bba"
import script from "./dol-radio.vue?vue&type=script&lang=js"
export * from "./dol-radio.vue?vue&type=script&lang=js"

import "./dol-radio.vue?vue&type=style&index=0&id=71d81bba&lang=scss"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__